/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TeamCheck = {
    properties: {
        name: {
            type: 'string',
            isRequired: true,
        },
        officialName: {
            type: 'string',
            isRequired: true,
        },
        logoUrl: {
            type: 'string',
            isRequired: true,
        },
        leagueId: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
